import 'css/src/components/common/UserDetailsSection';

import React from 'react';

import Avatar from 'js/src/components/common/ui/Avatar';
import { getUserInitials } from 'js/src/libs/custom-utils';

const UserDetailsSection = React.memo(function UserDetailsSection({
    photoUrl,
    firstName,
    lastName,
    email,
}: {
    photoUrl: string | null;
    firstName: string;
    lastName: string;
    email: string;
}) {
    return (
        <div className="user-details-section">
            <Avatar
                image={photoUrl}
                size="large"
                text={firstName || email ? getUserInitials(firstName, email) : 'user image'}
            />
            <div className="user-details-text">
                <span>
                    {firstName} {lastName}
                </span>
                <span>{email}</span>
            </div>
        </div>
    );
});

export default UserDetailsSection;
